import {useMemo} from 'react';

import {TreeViewSelection} from 'filters/features/FilterDialog/types';

import {useOptimizedTreeViewSelection} from 'filters/features/FilterDialog/sections/TreeViewSection/selections/useOptimizedTreeViewSelection';
import {ClientAgencyTreeNode} from 'modules/decisionsNext/hooks/trees/useClientAgencyCodesTree';

import {CounterTooltip} from 'filters/components/CounterTooltip';
import {SelectedTooltip} from 'filters/features/FilterDialog/components/SelectedTooltip';

export const useClientTagsTreeViewSelection: TreeViewSelection<string, ClientAgencyTreeNode> = (treeData, field) => {
  const selection = useOptimizedTreeViewSelection(treeData, field, {
    groupSelection: true,
  });

  return {
    ...selection,
    selectionCount: useMemo(() => {
      const selected = selection.isAllSelected ? [] : selection.selected;
      const treeMap = treeData.treeMap;

      if (!selected) {
        return;
      }

      const items = selected.map(code => treeMap.get(code)).filter(Boolean);

      return (
        <SelectedTooltip
          title={
            selected.length ? (
              <CounterTooltip
                total={`Client tags selected: ${selected.length}`}
                groups={[
                  {
                    title: 'Category',
                    count: items.filter(item => !item.parentKey).length,
                  },
                  {
                    title: 'Tag',
                    count: items.filter(item => item.parentKey).length,
                  },
                ]}
              />
            ) : null
          }
        >
          {selected.length || 'All'}
        </SelectedTooltip>
      );
    }, [selection.isAllSelected, selection.selected, treeData.treeMap]),
  };
};
